export default __webpack_public_path__ + "a3916b80f242bafc101f460052c2ee60.woff2";